class StepsController {

    constructor($scope, checkout) {
        this.$scope = $scope;
        this.checkout = checkout;
    }

    travel (index, step) {
        if (index <= this.checkout.laststep) {
            this.checkout.step = step;
            return this.checkout.travel();
        }
    }
}

StepsController.$inject = ['$scope', 'checkout'];

export default StepsController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/controllers/steps.controller.js